import { render, staticRenderFns } from "./MyPlacements.vue?vue&type=template&id=f2cd2f6e&"
import script from "./MyPlacements.vue?vue&type=script&lang=js&"
export * from "./MyPlacements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports